import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import Navigation from './components/Navigation';
import RequireAuth from './components/RequireAuth';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import PricingPage from './pages/PricingPage';
import ResourcesPage from './pages/ResourcesPage';
import DashboardPage from './pages/DashboardPage';

// Create a custom theme with purple primary color
const theme = createTheme({
  palette: {
    primary: {
      main: '#6d28d9', // purple-700
    },
    secondary: {
      main: '#2563eb', // blue-600
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
          <Route 
            path="/dashboard" 
            element={
              <RequireAuth>
                <DashboardPage />
              </RequireAuth>
            } 
          />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default App; 